<script>
	import ReasonableNumberInput from './ReasonableNumberInput.svelte'

	export let min = 0
	export let max = null
	export let step = 1
	export let precision = step
	export let value
	export let placeholder = null
	export let disabled = false
	export let autofocus = false
	export let allow_null_or_undefined = false
</script>

<ReasonableNumberInput
	bind:value
	{min}
	{max}
	{step}
	{precision}
	{placeholder}
	{disabled}
	{autofocus}
	{allow_null_or_undefined}
/>

<style>
	@media (hover: none) and (pointer: coarse) {
		:global(input[type="number"]) {
			padding-right: 11px;
		}
	}
</style>
